module.exports = __webpack_public_path__ + "img/device-desktop.8a5dff08.svg";